<form [formGroup]="taxRateForm" (ngSubmit)="submit()">
  <div class="row">
    <div class="col-md-6 mb-3">
      <generic-dropdown
        [items]="taxAuthoritiesList()"
        [label]="'Tax Authority'"
        [placeholder]="'Select Tax Authority'"
        formControlName="taxAuthorityId"
        [clearable]="true"
        [required]="true"
        [errormessage]="'Tax Authority is required'"
      ></generic-dropdown>
    </div>
    <div class="col-md-6 mb-3">
      <generic-dropdown
        [items]="taxCategoriesList()"
        [label]="'Tax Category'"
        [placeholder]="'Select Tax Category'"
        formControlName="taxCategoryId"
        [clearable]="true"
      ></generic-dropdown>
    </div>
    <div class="col-md-6 mb-3">
      <label class="form-label d-block">
        Effective Date
        <span class="text-danger">*</span>
      </label>
      <p-datepicker
        [showClear]="true"
        [showIcon]="true"
        [iconDisplay]="'input'"
        [showTime]="true"
        [hourFormat]="'12'"
        placeholder="Select Effective Date"
        formControlName="effectiveDate"
        styleClass="w-100"
        [appendTo]="'body'"
      ></p-datepicker>
    </div>
    <div class="col-md-6 mb-3">
      <input-field [label]="'Rate'" [type]="'number'" [placeholder]="'Enter Rate'" formControlName="rate"></input-field>
    </div>
  </div>
</form>
